export default "__VITE_ASSET__ekpcH2zZ__"